import React from "react";
import styled from "styled-components";

interface Props {
  nextStage: number;
  onClick: () => void;
}

const NextStageButton = ({ nextStage, onClick }: Props) => {
  return <Button onClick={onClick}>다음 문제 풀기</Button>;
};

export default NextStageButton;

const Button = styled.button`
  font-family: "iceSotong-Rg";

  cursor: pointer;

  color: white;
  border: none;

  border-radius: 10px;
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  background-image: linear-gradient(#e0583a, #2c0000);

  transition: 200ms;

  &:active {
    transform: scale(0.9);
  }
`;
